import { c as _c } from "react/compiler-runtime";
import { ScrollableContainer } from '../../../../components/scrollable-container/scrollable-container';
import { Table } from '../../../../components/table/table';
import { type MembershipRequirementBlock } from '../../../../utils/data/graphql/_generated/gql-generated';
import { MembershipLevel } from '../../../../utils/enums/membership';
import { type MembershipRequirementsPerYear } from '../../../../utils/types/membership-requirements';
import { type MembershipRequirementsBlockWithFallbacks } from '../../utils/helpers/add-fallbacks-to-membership-requirements-block';
import { useDataFieldRenderer } from '../../utils/hooks/use-data-field-renderer';
import { MembershipLevelLabel } from '../membership-level-label/membership-level-label';
import styles from './membership-dues.module.scss';
type MembershipDuesProps = {
  blockData: MembershipRequirementsBlockWithFallbacks;
  countryYearData?: MembershipRequirementsPerYear;
  isFetching: boolean;
  yearBlockData?: MembershipRequirementBlock;
};
export const MembershipDues = t0 => {
  const $ = _c(46);
  const {
    blockData,
    countryYearData,
    isFetching,
    yearBlockData
  } = t0;
  let t1;
  if ($[0] !== countryYearData || $[1] !== isFetching) {
    t1 = {
      basedOnSelectedCountry: false,
      countryYearData,
      isFetching
    };
    $[0] = countryYearData;
    $[1] = isFetching;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    renderDataField
  } = useDataFieldRenderer(t1);
  let t2;
  if ($[3] !== blockData.MembershipDuesAnchorLink) {
    t2 = blockData?.MembershipDuesAnchorLink && {
      id: blockData.MembershipDuesAnchorLink
    };
    $[3] = blockData.MembershipDuesAnchorLink;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== blockData.MembershipDuesStepLabel) {
    t3 = <h2 className={styles.wrapper__label}>{blockData.MembershipDuesStepLabel}</h2>;
    $[5] = blockData.MembershipDuesStepLabel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== blockData.MembershipDuesDescription) {
    t4 = <p className={styles.wrapper__description}>{blockData.MembershipDuesDescription}</p>;
    $[7] = blockData.MembershipDuesDescription;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== blockData.MembershipTableMemberHeading) {
    t5 = <th scope="column"><MembershipLevelLabel label={blockData.MembershipTableMemberHeading} membershipLevel={MembershipLevel.MDRT} /></th>;
    $[9] = blockData.MembershipTableMemberHeading;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== blockData.MembershipTableCoTHeading) {
    t6 = <th scope="column"><MembershipLevelLabel label={blockData.MembershipTableCoTHeading} membershipLevel={MembershipLevel.COT} /></th>;
    $[11] = blockData.MembershipTableCoTHeading;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== blockData.MembershipTableToTHeading) {
    t7 = <th scope="column"><MembershipLevelLabel label={blockData.MembershipTableToTHeading} membershipLevel={MembershipLevel.TOT} /></th>;
    $[13] = blockData.MembershipTableToTHeading;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <thead><tr>{t5}{t6}{t7}</tr></thead>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = yearBlockData?.MemberDues ?? undefined;
  let t10;
  if ($[19] !== renderDataField || $[20] !== t9) {
    t10 = renderDataField(t9);
    $[19] = renderDataField;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <td>{t10}</td>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = yearBlockData?.CoTDues ?? undefined;
  let t13;
  if ($[24] !== renderDataField || $[25] !== t12) {
    t13 = renderDataField(t12);
    $[24] = renderDataField;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = <td>{t13}</td>;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  const t15 = yearBlockData?.ToTDues ?? undefined;
  let t16;
  if ($[29] !== renderDataField || $[30] !== t15) {
    t16 = renderDataField(t15);
    $[29] = renderDataField;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16) {
    t17 = <td>{t16}</td>;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t11 || $[35] !== t14 || $[36] !== t17) {
    t18 = <tbody><tr>{t11}{t14}{t17}</tr></tbody>;
    $[34] = t11;
    $[35] = t14;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t18 || $[39] !== t8) {
    t19 = <ScrollableContainer><Table className={styles["membership-dues-table"]} tabIndex={0}>{t8}{t18}</Table></ScrollableContainer>;
    $[38] = t18;
    $[39] = t8;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t19 || $[42] !== t2 || $[43] !== t3 || $[44] !== t4) {
    t20 = <section className={styles.wrapper} {...t2}>{t3}{t4}{t19}</section>;
    $[41] = t19;
    $[42] = t2;
    $[43] = t3;
    $[44] = t4;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
};